/* import __COLOCATED_TEMPLATE__ from './android-platform.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type {
  INSTALLATION_METHOD,
  PROGRAMMING_LANGUAGES,
} from 'embercom/components/installation-new/constants';

interface Signature {
  Element: HTMLElement;
  Args: {
    selectedBackendInstallationMethod: INSTALLATION_METHOD | PROGRAMMING_LANGUAGES;
    backendInstallationMethods: any[];
    setSelectedBackendInstallationMethod: (method: string) => void;
    onPingDomainsCountChange: (count: number) => void;
    onPingDomainsUnresolvedErrorCountChange: (count: number) => void;
  };
}

export default class AndroidPlatform extends Component<Signature> {
  @tracked selectedAndroidLanguage = 'java';

  @action
  setSelectedAndroidLanguage(language: string) {
    this.selectedAndroidLanguage = language;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::AndroidPlatform': typeof AndroidPlatform;
  }
}
